var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('LogOn',{on:{"selectedCommercial":function($event){return _vm.$emit('selectedCommercial')}}}),_c('HeaderBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }